export default __webpack_public_path__ + "static/media/decada-0060-0010-min.a517cd6c.jpg";